import "./RemoveTask.scss";
import { useTranslation } from "react-i18next";

function RemoveTask({ cancelRemoveTask, removeTask }) {
  const { t } = useTranslation();
  return (
    <div className="remove-task-content">
      <div className="modal-title">
        <div>{t("tasks.modals.removeTask.title")}</div>
      </div>
      <div className="modal-body">
        <p>{t("tasks.modals.removeTask.message")}</p>
      </div>
      <div className="modal-form-buttons">
        <button className="modal-button cancel" onClick={cancelRemoveTask}>
          {t("common.cancel")}
        </button>
        <button className="modal-button delete" onClick={removeTask}>
          {t("common.remove")}
        </button>
      </div>
    </div>
  );
}

export default RemoveTask;
